<template>
	<sf-modal-layout size="l" :title="title" :show="show" :closeModal="close">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<comp-popup-search ref="CompPopupSearch" :scrId="scrId"></comp-popup-search>
				</sf-card>
			</div>

			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<comp-popup-table ref="table" @close="close" @reload="reload" @SendData="sendData" :scrId="scrId"></comp-popup-table>
				</sf-card>
			</div>
		</div>
		<template v-slot:footer>
			<sf-button line :onClick="() => close()">
				{{ getMessage_('MWCC000343') }}
			</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { serviceComputed, serviceMethods } from '@qms/comm/commpopup/CompPopup/store/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';

import CompPopupSearch from './Content/Search/CompPopupSearch.vue';
import CompPopupTable from './Content/Table/CompPopupTable.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { CompPopupSearch, CompPopupTable },
	data() {
		return {
			show: false,
			title: '업체정보',
			propCpnyCd: ''
			// userId: ''
		};
	},
	created() {
		this.setStateInit_();
		this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open(param) {
			this.setStateInit_();
			this.show = true;

			this.setSearchParam_({ key: 'cpnyScn', value: param.cpnyScn });
			this.setSearchParam_({ key: 'cpnyCd', value: param.cpnyCd });
			if (this.$refs.CompPopupSearch != undefined) {
				this.$refs.CompPopupSearch.searchList();
			}
		},
		close() {
			this.setSearchParam_({ key: 'cpnyCd', value: null });
			this.setSearchParam_({ key: 'cpnyScn', value: null });

			this.$refs.CompPopupSearch.reset();

			this.show = false;
		},
		reload(currentPage = 1, pageUnit = 10) {
			this.$refs.CompPopupSearch.searchList(currentPage, pageUnit);
		},
		sendData(sendParam) {
			this.$emit('SendData', sendParam);
			this.close();
		}
	}
};
</script>

<style></style>
